<script lang="ts" setup>
import DropArrow from "assets/icons/arrows/arrowDropdownFill.svg";
import DropArrowMobile from "assets/icons/arrows/arrowDownBlack.svg";

const props = defineProps<{
  dropName: string;
  dropHref?: string;
  dropLinks: {
    name: string;
    href: string;
  }[];
  isMobile: boolean | undefined;
}>();

const emits = defineEmits(["close-menu"]);
let menuDropTimeout: ReturnType<typeof setTimeout>;
const isMenuDrop = ref(false);

const toggleDrop = () => (isMenuDrop.value = !isMenuDrop.value);
const openDrop = () => (!props.isMobile ? (isMenuDrop.value = true) : null);
const closeDrop = (time?: number) => {
  if (!props.isMobile) {
    if (time) {
      menuDropTimeout = setTimeout(() => {
        isMenuDrop.value = false;
      }, time);
    } else {
      isMenuDrop.value = false;
    }
  }
};

const clearDropTimeout = () => {
  clearTimeout(menuDropTimeout);
};

const closeMenu = () => emits("close-menu");
</script>

<template>
  <div
    class="header__drop"
    :class="isMenuDrop && 'open'"
    v-click-outside="closeDrop"
  >
    <NuxtLink
      class="header__drop-visible svg-fill-orange"
      @click="toggleDrop"
      @mouseenter="openDrop"
      @mouseleave="closeDrop(300)"
    >
      <span>{{ dropName }}</span>
      <DropArrow class="header__drop-arrow header__drop-arrow_desktop" />
      <DropArrowMobile class="header__drop-arrow header__drop-arrow_mobile" />
    </NuxtLink>
    <div
      class="header__drop-hidden"
      @mouseenter="clearDropTimeout"
      @mouseleave="closeDrop(0)"
    >
      <NuxtLink
        :class="dropName === 'Поиск по VIN' && 'text-uppercase'"
        v-for="link in dropLinks"
        :key="`${link.name}-header-link`"
        :to="link.href"
        @click="closeMenu"
      >
        {{ link.name }}
      </NuxtLink>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header__drop {
  position: relative;

  &-arrow {
    &_desktop {
      @include md-breakpoint {
        display: none;
      }
    }
    &_mobile {
      display: none;
      @include md-breakpoint {
        display: block;
      }
    }
  }

  &.open {
    .header__drop {
      &-visible {
        color: $content_orange;
        @include md-breakpoint {
          color: $content_primary;
        }

        svg {
          transform: rotate(180deg);
          @include md-breakpoint {
            :deep(path) {
              fill: $content_primary;
            }
          }
        }
      }

      &-hidden {
        opacity: 1;
        visibility: visible;
        @include md-breakpoint {
          margin-top: 24px;
          max-height: min-content;
        }

        a {
          white-space: nowrap;
          @include font(14px, 20px);
          &:hover:not(:active) {
            @include mf-breakpoint {
              color: $control-content_orange;
            }
          }
        }
      }
    }
  }

  &-visible {
    display: flex;
    align-items: center;
    gap: 4px;
    @include font(14px, 16px);
    cursor: pointer;
    transition: color 0.3s;
    @include md-breakpoint {
      @include font(20px, 24px, 600);
      justify-content: space-between;
      height: 32px;
      padding-right: 8px;
    }

    &:hover:not(:active) {
      @include mf-breakpoint {
        color: $content_orange;
      }
    }

    svg {
      transition: transform 0.3s;
    }
  }

  &-hidden {
    min-width: 194px;
    position: absolute;
    top: calc(100% + 12px);
    left: -18px;
    background-color: $bg_page;
    z-index: 110;
    padding: 20px 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    box-shadow: 0 4px 18px 0 #0000001a;
    border-radius: 12px;
    transition: visibility 0.3s, opacity 0.3s;
    visibility: hidden;
    opacity: 0;
    @include md-breakpoint {
      position: static;
      top: auto;
      left: auto;
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
      gap: 24px;
      padding: 0;
      box-shadow: none;
      overflow: hidden;
      max-height: 0;
      transition: max-height 0.3s, margin-top 0.3s;
      border-radius: 0;

      a {
        font-size: 16px !important;
        font-weight: 400 !important;
        line-height: 20px !important;
      }
    }

    .text-uppercase {
      text-transform: uppercase;
    }
  }
}
</style>
